export const WorkspaceActions = {
  WORKSPACES_LOADED: "workspaces/loaded",
};
